<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Selecione os Campos </v-card-title>
        <ValidationProvider name="Mês" rules="required" v-slot="{ errors }">
          <v-select
            :error-messages="errors"
            :items="meses"
            item-text="descricao"
            item-value="id"
            v-model="selectMonth"
            return-object
            label="Selecione um mês"
            solo
          ></v-select>
        </ValidationProvider>
        <v-divider></v-divider>
        <ValidationProvider name="Franquia" rules="required" v-slot="{ errors }">
          <v-select
            :error-messages="errors"
            :items="franquiasList.filter((item) => !item.deleted_at)"
            :item-text="(item) => item.descricao"
            v-model="franquiaSelecionada"
            return-object
            label="Selecione uma franquia"
            solo
          ></v-select>
        </ValidationProvider>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="text" @click="$emit('dialogChange', !dialog)"> {{ cancelText }} </v-btn>
          <v-btn color="primary" text @click="emitChangeAction" :disabled="!validForm">
            {{ confirmText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    confirmText: {
      type: String,
      required: true,
    },
    cancelText: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("Franquias", ["franquiasList"]),
    validForm() {
      return !!this.selectMonth && !!this.franquiaSelecionada;
    },
  },
  data() {
    return {
      selectMonth: null,
      franquiaSelecionada: null,
      meses: [],
    };
  },
  methods: {
    ...mapActions("Franquias", ["loadFranquias"]),
    emitChangeAction() {
      if (this.validForm) {
        this.$emit("changeAction", this.selectMonth, this.franquiaSelecionada);
      }
    },
  },
  async mounted() {
    try {
      this.meses = await this.$services.anosService.meses();
      await this.loadFranquias();
    } catch (error) {
      this.$handleError(error);
    }
  },
};
</script>

<style lang="scss" scoped></style>
